<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-equities page-operative-data-analysis-equities-edit">
    <div class="container">
      <PageTitle>Modifica equity</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Equity da modificare non trovato</div>
      <FormEquity v-else-if="company && userCanEdit" :equity="equity" edit @saved="saveEquity" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-equities-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormEquity: () => import('../../../../components/Operative/Form/FormEquity'),
  },
  data () {
    return {
      equity: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveEquity (equity) {
      this.$api.updateEquity(this.company.id, equity.id, equity)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.equity',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getEquity(this.company.id, this.$route.params.equityId)
          .then(res => {
            this.equity = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
